module.exports = __webpack_public_path__ + "static/media/4.ae45cb0a.webp";